


export const getPermissions = (planId) =>{
    var planPermissions = {}

    switch(planId) {
        case 'price_HJBaYjGF19qCRO': 
            planPermissions = {
                noOfCampaignAllowed:'1',
                noOfNotificationAllowed:'1',
                noOfGoalsAllowed:'1'
            }
            break;
        case 'price_1HHRfQCkWzi7OrXWqa85Hhvi': 
            planPermissions = {
                noOfCampaignAllowed:'1',
                noOfNotificationAllowed:'1',
                noOfGoalsAllowed:'1'
            }
            break;
        default:

        planPermissions = {
            noOfCampaignAllowed:'200000000',
            noOfNotificationAllowed:'6',
            noOfGoalsAllowed:'20000000'
        }
          
      }

   return planPermissions
}

export const customNotifPermission = [
    "price_1HiD20CkWzi7OrXWvCZVywSQ",
    "price_1HQbLBCkWzi7OrXWJob8bWxU",
    "price_1H9qZ8CkWzi7OrXWUbIVZRGJ",
    "price_1H89N4CkWzi7OrXW1y4N40Ye",
    // "plan_H5i9GLVRtSZ4E7"
]